import React from "react";
import Header from "../../common/Header";
import FAQSection from "./Components/FAQSection";
import Footer from "../../common/Footer";
import ExternalScripts from "../../common/ExternalScripts";

const FAQ = () => {
  return (
    <div>
      <div className='boxcar-wrapper' style={{backgroundColor:"#050B20"}} >
       <div style={{paddingBottom:"220px"}} >
      <Header preclass="normal"  />
      </div>
      <ExternalScripts/>

      <FAQSection />
      <Footer />
      </div>
    </div>
  );
};

export default FAQ;
